import React, { useState } from "react"

import EventPageHeader from "../common/EventPageHeader"

interface TrialBlockPageHeaderProps {
  viewMode: "calendar" | "table"
  setViewMode: (mode: "calendar" | "table") => void
  showCreateButton?: boolean
}

const TrialBlockPageHeader: React.FC<TrialBlockPageHeaderProps> = ({
  viewMode,
  setViewMode,
  showCreateButton = true,
}) => {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false)

  return (
    <EventPageHeader
      title="Trial Blocks"
      viewMode={viewMode}
      setViewMode={setViewMode}
      isCreateDialogOpen={isCreateDialogOpen}
      setIsCreateDialogOpen={setIsCreateDialogOpen}
      createButtonLabel="Create Trial Block"
      showCreateButton={showCreateButton}
      toggleType="trial"
    >
      {/* This empty fragment is provided as children to satisfy the type requirement */}
      <></>
    </EventPageHeader>
  )
}

export default TrialBlockPageHeader
